<script setup lang="ts">
    // import { VueQueryDevtools } from '@tanstack/vue-query-devtools';
    import { watch } from 'vue';
    import { RouterView, useRoute } from 'vue-router';
    import { useAppStore } from '../stores/app';
    import { __ } from '../stores/expressions';
    import { useNavigationStore } from '../stores/navigation';
    import ConfirmationDialog from './ConfirmationDialog.vue';
    import Navigation from './navigation/Navigation.vue';
    import PermissionGuard from './PermissionGuard.vue';
    import BackOfficeToolbar from '../back-office/components/BackOfficeToolbar.vue';
    import ToastContainer from './ToastContainer.vue';
    import SuccessDialog from './SuccessDialog/SuccessDialog.vue';
    import { Role, usePermissions } from '../composables/usePermissions';

    const app = useAppStore();
    const navigation = useNavigationStore();
    const route = useRoute();
    const { hasRole } = usePermissions();

    watch(
        () => app.title,
        () => {
            document.title = app.title ? `${app.title}` : 'Indicate me';
        },
        { immediate: true }
    );
</script>

<template>
    <template v-if="route.meta.public || route.meta.preview">
        <RouterView />
    </template>
    <template v-else>
        <div class="relative z-10 min-h-screen">
            <Navigation />

            <main :class="navigation.visible ? 'sm:pl-72' : 'sm:pl-16'">
                <BackOfficeToolbar v-if="hasRole(Role.SYSOP)" />
                <PermissionGuard />
            </main>
        </div>
        <ToastContainer />
        <ConfirmationDialog />
        <SuccessDialog />
        <Transition name="slide">
            <div
                v-if="app.loading"
                class="bottom-3 right-3 bg-white text-sm absolute z-30 rounded-full px-3 py-1"
            >
                {{ __('loading') }}
            </div>
        </Transition>
        <!-- <VueQueryDevtools /> -->
    </template>
</template>
